import React from 'react'
import { useParams, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import portfolio from '../../../js/portfolio/portfolio';

import Navigation from '../../common/Navigation';
import Footer from '../../common/Footer';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import TechStack from './TechStack';

const PortfolioDetailed = () => {
    const { id } = useParams();
    const portfolioData = portfolio.find(p => p.id === id);
  
    if (!portfolioData) return <p>Project not found</p>;
    
    return (
        <section id='PortfolioDetailed'>
            <Navigation />

            <div className="portfolio-detailed-wrapper">
                <div className="pd-heading">
                    <Link to={`/portfolio`} className="pd-back-wrap">
                        <div className="pd-back">
                            <FontAwesomeIcon icon={faChevronLeft} />
                            <span>Back</span>
                        </div>
                    </Link>
                    <div className="pd-title-wrap">
                        <h1 className="pd-title">
                            {portfolioData.title}
                        </h1>
                        <h3 className="pd-subtitle">
                            {portfolioData.completion_year} - {portfolioData.short_description}
                        </h3>
                    </div>
                </div>
                <div className="pd-body">
                    <div className="pdb-img-wrapper">
                        <img src={portfolioData.cover_image} alt={portfolioData.title} />
                    </div>

                    {portfolioData.redirect && portfolioData.redirect.trim() !== "" && (
                        <a
                            href={portfolioData.redirect}
                            className="pdb-to-project"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span>View Project</span>
                        </a>
                    )}

                    <div className="pd-grid">
                        <div className="pdg-item">
                            <h3>Description</h3>
                            <p>{portfolioData.description}</p>
                        </div>
                        <div className="pdg-item">
                            <h3>Techstack</h3>
                            <ul>
                                {/* {portfolioData.stack.map((tech, index) => (
                                    <li key={index}>{tech}</li>
                                ))} */}
                                <TechStack stack={portfolioData.stack} />
                            </ul>
                        </div>
                        <div className="pdg-item">
                            <h3>Role</h3>
                            <p>{portfolioData.role}</p>
                        </div>
                        <div className="pdg-item">
                            <h3>Timeline</h3>
                            <p>{portfolioData.timeline}</p>
                        </div>
                    </div>
                </div>
                <div className="pd-carousel">
                    
                </div>
            </div>

            <Footer />
        </section>
    )
}

export default PortfolioDetailed